
import { computed, defineComponent } from 'vue'

export default defineComponent({
    name: 'Number',
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        max: {
            type: String,
            required: false,
            default: ''
        },
        min: {
            type: String,
            required: false,
            default: ''
        },
        modelValue: {
            type: Number,
            required: false,
            default: 0
        },
        step: {
            type: String,
            required: false,
            default: '1'
        }
    },
    emits: ['update:modelValue'],
    setup (props, { emit }) {
        const value = computed({
            get () {
                return props.modelValue
            },
            set (value) {
                emit('update:modelValue', value)
            }
        })

        return { value }
    }
})
